module.exports = "../fonts/HelveticaNeueLTW01-56Italic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-56Italic.ttf
// module id = A0Jf
// module chunks = 1